import { Box, Flex, Group, Loader, Paper, Text, TextInput } from '@mantine/core';
import { FC, useState } from 'react';
import { Button } from 'ui/Button';
import styles from './Rate.module.scss';
import { ReactComponent as IconCalendar } from './img/iconCalendar.svg';
import { formatEndDateWithYear } from 'utils/date';
import {
  useGetProfileQuery,
  usePromoCodeMutation,
} from 'redux/Api/profileApi/ProfileApi';

export const Rate: FC = () => {
  const { data } = useGetProfileQuery();
  const [applyPromoCode, { isLoading }] = usePromoCodeMutation();
  const [promoCode, setPromoCode] = useState('');
  const [promoCodeError, setPromoCodeError] = useState('');

  const handlePromoCode = async () => {
    setPromoCodeError('');
    await applyPromoCode({
      body: {
        code: promoCode,
      },
    }).then((data: any) => {
      if (data?.data) {
        setPromoCodeError('');
      }
      if (data.error) {
        setPromoCodeError(data.error.data.message);
      }
    });
  };

  return (
    <Box>
      <div className={styles.root}>
        <Text fz='20px' fw='600' lh='24px'>
          Текущий тариф – {data?.commission?.percent}%
        </Text>

        {data?.promo_code ? (
          <Paper mt='20px' bg='#F8FAFD' p='12px' maw={'745px'} radius={'8px'}>
            <Text fz='16px' fw='600' lh='22px'>
              Промокод
            </Text>
            <Group mt='12px' align='center' gap={'8px'} lh='18px'>
              <IconCalendar />
              <Text fz='14px' fw='400'>
                Активен до {formatEndDateWithYear(data?.promo_code?.expires_at)}
              </Text>
            </Group>
          </Paper>
        ) : (
          <Paper mt='20px' bg='#F8FAFD' p='12px' maw={'745px'} radius={'8px'}>
            <Text fz='16px' fw='600' lh='22px'>
              Промокод
            </Text>
            <Flex
              mt='12px'
              align='flex-end'
              direction={{ base: 'column', sm: 'row' }}
              gap={{ base: '12px', sm: '4px' }}>
              <TextInput
                flex='1'
                w={{ base: '100%', sm: 'auto' }}
                placeholder='Код'
                maxLength={10}
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
                maw={{ base: '100%', sm: '566px' }}
                styles={{
                  input: { height: '48px', fontSize: '16px', border: 'none' },
                }}
                mr={{ base: '0', sm: '12px' }}
                label={
                  <Text fz='14px' fw='400' c='#71869D' mb='6px'>
                    Введи промокод
                  </Text>
                }
              />
              <Button
                className={styles.btn}
                size='L'
                onClick={handlePromoCode}
                theme='filed'>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  Применить {isLoading && <Loader size='xs' color='white' />}
                </div>
              </Button>
            </Flex>
            {promoCodeError && (
              <Text fz='14px' fw='400' c='#E10D0D' mt='6px'>
                {promoCodeError}
              </Text>
            )}
          </Paper>
        )}
      </div>
    </Box>
  );
};
